import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { X } from "lucide-react";

const DEMO_EMAIL = "reviewer@transportmate.app";

const DISMISSED_KEY = "demo-banner-dismissed";

export function DemoBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(DISMISSED_KEY)) return;
    supabase.auth.getUser().then(({ data }) => {
      if (data.user?.email === DEMO_EMAIL) {
        setVisible(true);
        const timer = setTimeout(() => dismiss(), 10000);
        return () => clearTimeout(timer);
      }
    });
  }, []);

  const dismiss = () => {
    setVisible(false);
    sessionStorage.setItem(DISMISSED_KEY, "1");
  };

  if (!visible) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] max-w-md w-[calc(100%-2rem)] animate-in fade-in slide-in-from-top-2 duration-300">
      <div className="flex items-center gap-2 rounded-lg bg-primary/90 text-primary-foreground px-4 py-2.5 text-sm shadow-lg backdrop-blur-sm">
        <span className="flex-1">
          <strong>Demo Account:</strong> Sample transport jobs are preloaded for App Store review and demonstration purposes.
        </span>
        <button
          onClick={dismiss}
          className="shrink-0 rounded-full p-0.5 hover:bg-primary-foreground/20 transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
